import styled from 'styled-components';

import { Text } from '../../../../components/Text/Text';
import { ART_STYLE, COLORS, SPACE } from '../../../../theme/tokens';

/** Where the studio will be: the card's body, centred, at least as tall as a studio's start. */
export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${SPACE[12]};
  min-height: ${ART_STYLE.DRAFT_MIN_PX}px;
  padding: ${SPACE[24]} ${SPACE[16]};
  text-align: center;
`;

export const Title = styled(Text)`
  margin-top: ${SPACE[4]};
  font-size: 17px;
  font-weight: 600;
  line-height: 1.35;
  color: ${COLORS.text};
`;

export const Lead = styled(Text)`
  max-width: 46ch;
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;

/** The button sits a step below the copy. */
export const Action = styled.div`
  margin-top: ${SPACE[8]};
`;
